function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import classNames from 'classnames';
import map from 'lodash/map';
import React, { useCallback, useRef, useState } from 'react';
import { PRODUCT_DELIVERY_METHOD, PRODUCT_TYPE } from '../../../constants/product';
import useEventListener from '../../../hooks/useEventListener';
import text from '../../../text';
import OutlinedText from '../../text/OutlinedText';
import { getAddOnConfig } from '../drawingManager/utilities';
import ProductControlsButton from './ProductControlsButton';
export var PRODUCT_CONTROLS_ID = 'ProductControls-wrapper';
var productsByDeliveryMethod = {
    draft: [
        {
            productType: PRODUCT_TYPE.UNKNOWN
        }
    ],
    database: [
        {
            productType: PRODUCT_TYPE.AERIAL
        },
        {
            productType: PRODUCT_TYPE.STREETSCAPE
        }
    ],
    capture: [
        {
            productType: PRODUCT_TYPE.DRONE
        },
        {
            productType: PRODUCT_TYPE.EXTERIOR
        },
        {
            productType: PRODUCT_TYPE.INTERIOR
        }
    ],
    addOns: [
        {
            productType: PRODUCT_TYPE.BIM_EXTERIOR
        },
        {
            productType: PRODUCT_TYPE.BIM_INTERIOR
        },
        {
            productType: PRODUCT_TYPE.TWOD_PLAN_EXTERIOR
        },
        {
            productType: PRODUCT_TYPE.TWOD_PLAN_INTERIOR
        }
    ]
};
var ProductControls = function() {
    var _useState = _sliced_to_array(useState(false), 2), isScrollable = _useState[0], setIsScrollable = _useState[1];
    var productControlsRef = useRef(null);
    var isElementHeightScrollable = function(element) {
        var clientHeight = element.clientHeight, scrollHeight = element.scrollHeight;
        return setIsScrollable(scrollHeight > clientHeight);
    };
    var setScrollableOnResize = useCallback(function() {
        if (!productControlsRef.current) return;
        isElementHeightScrollable(productControlsRef.current);
    }, [
        productControlsRef
    ]);
    useEventListener('resize', setScrollableOnResize);
    return /*#__PURE__*/ React.createElement("div", {
        id: PRODUCT_CONTROLS_ID,
        className: classNames('ProductControls', {
            scrollable: isScrollable
        }),
        ref: function(element) {
            // necessary to add callback to set ref on load of ProductControl component
            // especially on smaller screen
            if (!element) return;
            productControlsRef.current = element;
            isElementHeightScrollable(element);
        }
    }, map(productsByDeliveryMethod, function(products, deliveryMethod) {
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: deliveryMethod
        }, /*#__PURE__*/ React.createElement("div", {
            className: "position-relative"
        }, /*#__PURE__*/ React.createElement(OutlinedText, {
            label: text(PRODUCT_DELIVERY_METHOD[deliveryMethod]),
            svgProps: {
                width: '60px'
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: "product-control-button-group"
        }, map(products, function(param) {
            var productType = param.productType;
            var isAddOn = !!getAddOnConfig(productType);
            var withExplanation = productType === PRODUCT_TYPE.UNKNOWN || isAddOn;
            return /*#__PURE__*/ React.createElement(ProductControlsButton, {
                key: productType,
                productType: productType,
                variant: productType === PRODUCT_TYPE.UNKNOWN ? 'tertiary' : 'default',
                withExplanation: withExplanation,
                deliveryMethod: deliveryMethod
            });
        }))));
    }));
};
export default ProductControls;
